import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GeckoFields, GECKO_UTILS, GeckoToastService } from 'ui';

class MailgunChannelForm extends Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    onChange: () => {},
  };

  changeHandler(key, value) {
    if (
      key === 'configuration.pretty_email' ||
      key === 'configuration.sender_name' ||
      key === 'configuration.reply_to'
    ) {
      if (this.validateValue(value)) {
        new GeckoToastService().error('This field must not contain < or >');
        value = value.replace(/<|>/, '');
        const newValue = GECKO_UTILS.setNestedValue(
          this.props.value,
          key,
          value
        );
        return this.props.onChange(newValue);
      }
    }
    const newValue = GECKO_UTILS.setNestedValue(this.props.value, key, value);
    this.props.onChange(newValue);
  }

  validateValue(value) {
    return new RegExp(/[<>]/).test(value);
  }

  fields = [
    {
      key: 'configuration.random_key',
      type: 'custom',
      label: 'Your GeckoChat email address',
      description:
        'Forward messages from your email account to GeckoChat using the email address below.',
      width: 'col-xs-12',
      hideWhen: () => !this.props.value.configuration.email_key,
      component: (
        <code>
          <pre>{`${this.props.value.configuration.email_key}@m.geckochat.io`}</pre>
        </code>
      ),
    },
    {
      key: 'name',
      type: 'text',
      label: 'Channel Title',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.pretty_email',
      label: 'Sending email address',
      description:
        'This is the email address from which your messages will appear to be sent.',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.sender_name',
      label: 'Sender name',
      description: `Choose the name to appear as the sender of emails from this channel.`,
      width: 'col-xs-12',
      required: false,
    },
    {
      key: 'configuration.reply_to',
      label: 'Reply to option',
      description:
        'Allows you to configure a different receiving email address for replies on messages sent through this channel.',
      width: 'col-xs-12',
      required: false,
    },
  ];

  render() {
    return (
      <GeckoFields
        fields={this.fields}
        values={this.props.value}
        handler={this.changeHandler.bind(this)}
      />
    );
  }
}

export default MailgunChannelForm;
